export default function HomePage() {
  return (
    <>
      {/* JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "掌中的美母",
            url: "https://realinsight.github.io/",
            description:
              "探索「掌中的美母」的独特魅力与深层内涵，全方位呈现掌中的美母的核心价值、使用场景与真实体验。",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://realinsight.github.io/search?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "掌中的美母",
            url: "https://realinsight.github.io/",
            description:
              "掌中的美母致力于传承中华母爱文化，为现代人提供温暖的精神陪伴与情感寄托。",
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "掌中的美母适合什么样的人群？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "掌中的美母适合所有渴望在忙碌生活中寻找温暖与力量的人。无论您是年轻的职场人士、退休的长者，还是正在求学的大学生，掌中的美母都能为您带来独特的情感体验和精神陪伴。",
                },
              },
              {
                "@type": "Question",
                name: "掌中的美母的核心价值是什么？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "掌中的美母的核心价值在于它作为情感载体和文化符号的双重身份。它既承载着中华民族千年来对母性力量的崇敬与赞美，又以现代化的方式为当代人提供了一个回归内心、感受温暖的精神空间。",
                },
              },
              {
                "@type": "Question",
                name: "如何更好地了解和体验掌中的美母？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "我们建议您从了解掌中的美母的文化内涵开始，通过阅读我们的深度文章和真实用户故事，逐步建立对掌中的美母的认知。",
                },
              },
              {
                "@type": "Question",
                name: "掌中的美母可以作为礼物赠送吗？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "当然可以！掌中的美母是一份极具心意的礼物选择。它所蕴含的关于爱、关怀与感恩的美好寓意，使其成为母亲节、生日、纪念日等特殊时刻的完美礼物。",
                },
              },
              {
                "@type": "Question",
                name: "掌中的美母与其他类似产品有什么不同？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "掌中的美母的独特之处在于其深厚的文化根基和真挚的情感价值。它不仅仅是一件物品，更是一种文化的传承和情感的寄托。",
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}